import React, { useState, useEffect, useMemo } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableSortLabel,
    Typography,
    Checkbox,
    Button,
    IconButton,
    Chip,
    Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VestiyerConfirmationDialog from './VestiyerConfirmationDialog';
import VehicleConfirmationDialog from './VehicleConfirmationDialog';
import { tokenService } from 'src/services';
import Services from 'src/services/Services';
import { toast } from 'react-toastify';


export function CutomerVehicleApprovalModal({
    open,
    onClose,
    data = [],
    type,
    getRows
}) {
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const mallID = (tokenService.getUser().firstResponsibleOffice.mallID);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [orderVehicle, setOrderVehicle] = useState('asc');
    const [orderByVehicle, setOrderByVehicle] = useState('code');
    const [vehicleNoInputs, setVehicleNoInputs] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [vehicleNumbers, setVehicleNumbers] = useState([]);
    const [selectingVehicleFor, setSelectingVehicleFor] = useState(null);
    const [selectedVehicleCode, setSelectedVehicleCode] = useState('');
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [confirmData, setConfirmData] = useState();
    const [showSucces, setShowSucces] = useState(false);
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [paymentIdConfirmed, setPaymentIdConfirmed] = useState(false);
    const [isUpdatingPaymentId, setIsUpdatingPaymentId] = useState(false);

    const getVehicleColorByBarcode = (barcode) => {
        if (!barcode) return '';
        const match = vehicleOptions?.find((item) => item.barcode === barcode);
        return match?.color || '';
    };

    const getPaymentType = (row) =>
        String(row?.item?.paymentType || '').toLowerCase();

    const isPhysicalPos = (row) => getPaymentType(row) === "physical-pos";
    const isCashPayment = (row) => getPaymentType(row) === "cash";
    const requiresPhysicalPaymentFlow = (row) => isPhysicalPos(row) || isCashPayment(row);

    const handleOpenDialog = () => {
        setDialogOpen(true);
    };
    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleConfirm = () => {
        if (requiresInvoice && !invoiceNumber.trim()) {
            toast.error("Fatura/Fiş No zorunludur.");
            return;
        }

        const list = Array.isArray(confirmData) ? confirmData : [confirmData];

        const needsPaymentUpdate = list.filter(
            (x) => requiresPhysicalPaymentFlow(x) && x?.item?.isPaid !== "1"
        );

        const doApprove = () => {
            let sendRequest
            if (type !== "gift") {
                sendRequest = (item) =>
                    Services.VehiclesApproveRequest(
                        parsedUser.token,
                        item.item.requestID,
                        item.item.poiID,
                        item.currentVehicleNo,
                        item.currentVehicleColor
                    );
            }
            else {
                sendRequest = (item) =>
                    Services.VehiclesApproveRequest(
                        parsedUser.token,
                        item.item.requestID,
                        item.item.poiID,
                        false,
                        ''
                    );
            }

            const requests = list.map(data => sendRequest(data));

            Promise.all(requests)
                .then(responses => {
                    const allSuccess = responses.every(res => res.data.status);
                    if (allSuccess) {
                        setShowSucces(true);
                        getVehicleInventory();
                        getRows();
                    } else {
                        toast.error("Bazı onaylar başarısız oldu.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    toast.error("Onay işlemi sırasında bir hata oluştu.");
                });
        };

        if (needsPaymentUpdate.length === 0) {
            doApprove();
            return;
        }

        setIsUpdatingPaymentId(true);
        const updateRequests = needsPaymentUpdate
            .map(x => x?.item?.requestID)
            .filter(Boolean)
            .map((requestId) =>
                Services.UpdatePaymentIDForPhysicalPayment(parsedUser.token, requestId, invoiceNumber)
            );

        Promise.all(updateRequests)
            .then((responses) => {
                const allSuccess = responses.every((res) => res.data?.status);
                if (allSuccess) {
                    setPaymentIdConfirmed(true);
                    doApprove();
                } else {
                    toast.error("Ödeme güncellemesi başarısız oldu.");
                }
            })
            .catch(() => {
                toast.error("Ödeme güncellemesi sırasında hata oluştu.");
            })
            .finally(() => setIsUpdatingPaymentId(false));
    };


    useEffect(() => {
        if (open) {
            getVehicleInventory()
            const initialVehicle = {};
            data.forEach(item => {
                initialVehicle[item.id] = item.item.vehicleID !== "-" ? item.item.vehicleID : '';
            });
            setVehicleNoInputs(initialVehicle);
            setSelectedRows({});
            setSelectAll(false);
            setSelectingVehicleFor(null);
            setSelectedVehicleCode('');
        }
    }, [open, data]);

    const getVehicleInventory = () => {
        Services.GetVehicleInventory(parsedUser.token, mallID)
            .then(res => {
                if (res.data.status) {
                    console.log(res.data.result)
                    setVehicleOptions(res.data.result.vehicleInventory[type])
                }
            })
    }

    const handleRequestSort = (property) => () => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleRequestSortVehicle = (property) => () => {
        const isAsc = orderByVehicle === property && orderVehicle === 'asc';
        setOrderVehicle(isAsc ? 'desc' : 'asc');
        setOrderByVehicle(property);
    };

    const handleSelectAll = (event) => {
        const checked = event.target.checked;
        setSelectAll(checked);
        const newSelected = {};
        data.forEach(item => {
            console.log(item);
            const hasVehicleNo = vehicleNoInputs[item.id]?.trim();
            const isPaid = item.item.isPaid === "1";
            const canApproveUnpaidPhysicalPos = requiresPhysicalPaymentFlow(item);
            if (type !== "gift") {
                newSelected[item.id] = hasVehicleNo && (isPaid || canApproveUnpaidPhysicalPos) ? checked : false;
            }
            else {
                newSelected[item.id] = isPaid || canApproveUnpaidPhysicalPos ? checked : false;
            }
        });
        setSelectedRows(newSelected);
    };
    const handleSelectRow = (id) => (event) => {
        const checked = event.target.checked;
        setSelectedRows(prev => ({ ...prev, [id]: checked }));
    };

    const sortedData = useMemo(() => {
        const dataCopy = [...data];
        dataCopy.sort((a, b) => {
            let aVal, bVal;
            if (orderBy === 'vehicleNo') {
                aVal = vehicleNoInputs[a.id] || a.vehicleNo || '';
                bVal = vehicleNoInputs[b.id] || b.vehicleNo || '';
            } else if (orderBy === 'paketAdeti') {
                aVal = a.paketAdeti || 0;
                bVal = b.paketAdeti || 0;
                return order === 'asc' ? aVal - bVal : bVal - aVal;
            } else {
                aVal = (a[orderBy] || '').toString();
                bVal = (b[orderBy] || '').toString();
            }

            return order === 'asc'
                ? aVal.localeCompare(bVal)
                : bVal.localeCompare(aVal);
        });
        return dataCopy;
    }, [data, order, orderBy, vehicleNoInputs]);

    const sortedVehicleOptions = useMemo(() => {
        if (type !== "gift") {
            const arr = [...vehicleOptions];

            arr.sort((a, b) => {
                let aVal = (a[orderByVehicle] || '').toString();
                let bVal = (b[orderByVehicle] || '').toString();
                return orderVehicle === 'asc'
                    ? aVal.localeCompare(bVal)
                    : bVal.localeCompare(aVal);
            });
            return arr;
        }
    }, [orderVehicle, orderByVehicle, vehicleOptions]);

    const handleApproveSingle = (row) => () => {
        const currentVehicleNo =
            vehicleNoInputs[row.id] || row.vehicleNo || '';

        setVehicleNumbers([currentVehicleNo]);
        setConfirmData({
            ...row,
            currentVehicleNo,
            currentVehicleColor: getVehicleColorByBarcode(currentVehicleNo)
        });
        setInvoiceNumber('');
        setPaymentIdConfirmed(false);
        handleOpenDialog();
    };

    const handleApproveAll = () => {
        const selectedData = data.filter(item => selectedRows[item.id]);

        const selectedDataWithVehicle = selectedData.map(item => ({
            ...item,
            currentVehicleNo: vehicleNoInputs[item.id] || item.vehicleNo || '',
            currentVehicleColor: getVehicleColorByBarcode(
                vehicleNoInputs[item.id] || item.vehicleNo || ''
            )
        }));

        const currentVehicleNos = selectedDataWithVehicle.map(
            i => i.currentVehicleNo
        );
        setVehicleNumbers(currentVehicleNos);
        setConfirmData(selectedDataWithVehicle);
        setInvoiceNumber('');
        setPaymentIdConfirmed(false);
        handleOpenDialog();
    };

    const requiresInvoice = useMemo(() => {
        if (!confirmData) return false;
        const list = Array.isArray(confirmData) ? confirmData : [confirmData];
        return list.some(x => requiresPhysicalPaymentFlow(x));
    }, [confirmData]);

    const handleUpdatePaymentId = () => {
        if (!requiresInvoice) return;
        if (!invoiceNumber.trim()) {
            toast.error("Fatura/Fiş No zorunludur.");
            return;
        }

        const list = Array.isArray(confirmData) ? confirmData : [confirmData];
        const requestIds = list.map(x => x?.item?.requestID).filter(Boolean);
        if (requestIds.length === 0) {
            toast.error("Request ID bulunamadı.");
            return;
        }

        setIsUpdatingPaymentId(true);
        const requests = requestIds.map((requestId) =>
            Services.UpdatePaymentIDForPhysicalPayment(parsedUser.token, requestId, invoiceNumber)
        );

        Promise.all(requests)
            .then((responses) => {
                const allSuccess = responses.every((res) => res.data?.status);
                if (allSuccess) {
                    setPaymentIdConfirmed(true);
                    toast.success("Fatura/Fiş doğrulaması başarılı.");
                } else {
                    setPaymentIdConfirmed(false);
                    toast.error("Fatura/Fiş doğrulaması başarısız.");
                }
            })
            .catch(() => {
                setPaymentIdConfirmed(false);
                toast.error("Fatura/Fiş doğrulaması sırasında hata oluştu.");
            })
            .finally(() => setIsUpdatingPaymentId(false));
    };

    const hasSelectedRows = Object.values(selectedRows).some(Boolean);

    const handleVehicleButtonClick = (rowId) => () => {
        setSelectingVehicleFor(rowId);
        setSelectedVehicleCode(vehicleNoInputs[rowId] || '');
    };

    const handleVehicleRowClick = (item) => () => {
        if (selectedVehicleCode === item.barcode) {
            setSelectedVehicleCode('');
        } else {
            setSelectedVehicleCode(item.barcode);
        }
    };

    const handleConfirmVehicleSelection = () => {
        setVehicleNoInputs(prev => ({
            ...prev,
            [selectingVehicleFor]: selectedVehicleCode
        }));

        if (!selectedVehicleCode) {
            setSelectedRows(prev => ({
                ...prev,
                [selectingVehicleFor]: false
            }));
        }

        setSelectingVehicleFor(null);
        setSelectedVehicleCode('');
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ m: 0, p: 2, position: 'relative' }}>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {selectingVehicleFor === null ? (
                <>
                    <DialogTitle
                        sx={{
                            m: 0,
                            p: 2,
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography sx={{ color: 'rgba(68, 68, 68, 1)', fontWeight: '700', fontSize: '22px' }}>
                            Onay Bekleyen Müşteri Listesi
                        </Typography>
                        <Typography sx={{ color: 'rgba(182, 182, 182, 1)', fontWeight: '400', fontSize: '16px' }}>
                            Lütfen müşteri işlemini başlatmak için bekleyen işlemleri onaylayınız.
                        </Typography>
                    </DialogTitle>

                    <DialogContent>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: 'white' }}>
                                    <TableCell sx={{ backgroundColor: 'white' }} padding="checkbox">
                                        <Checkbox
                                            color="primary"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: 'white' }}
                                        sortDirection={orderBy === 'name' ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === 'name'}
                                            direction={orderBy === 'name' ? order : 'asc'}
                                            onClick={handleRequestSort('name')}
                                        >
                                            Müşteri Adı
                                        </TableSortLabel>
                                    </TableCell>
                                    {type !== "gift" &&
                                        <TableCell
                                            sx={{ backgroundColor: 'white' }}
                                            sortDirection={orderBy === 'vehicleNo' ? order : false}
                                        >
                                            <TableSortLabel
                                                active={orderBy === 'vehicleNo'}
                                                direction={orderBy === 'vehicleNo' ? order : 'asc'}
                                                onClick={handleRequestSort('vehicleNo')}
                                            >
                                                Araç No
                                            </TableSortLabel>
                                        </TableCell>
                                    }

                                    <TableCell
                                        sx={{ backgroundColor: 'white' }}
                                        sortDirection={orderBy === 'paketAdeti' ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === 'paketAdeti'}
                                            direction={orderBy === 'paketAdeti' ? order : 'asc'}
                                            onClick={handleRequestSort('paketAdeti')}
                                        >
                                            {type === "gift" ? "Paket Adedi" : "Araç Adedi"}
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: 'white' }}
                                        sortDirection={orderBy === 'paketNotu' ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === 'paketNotu'}
                                            direction={orderBy === 'paketNotu' ? order : 'asc'}
                                            onClick={handleRequestSort('paketNotu')}
                                        >
                                            Ödeme Durumu
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: 'white', color: 'rgba(107, 114, 128, 1)', fontWeight: 500 }}>
                                        İşlem
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {sortedData.map((row, index) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{
                                            backgroundColor: (index + 1) % 2 !== 0
                                                ? 'rgba(249,250,251,1)'
                                                : 'white'
                                        }}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={!!selectedRows[row.id]}
                                                onChange={handleSelectRow(row.id)}
                                                // Eğer araç kodu boşsa hem disabled hem unchecked
                                                disabled={
                                                    (!vehicleNoInputs[row.id]?.trim() ||
                                                        (row?.item?.isPaid !== "1" && !requiresPhysicalPaymentFlow(row))) &&
                                                    type !== "gift"
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <div>
                                                <Typography
                                                    sx={{
                                                        fontWeight: '500',
                                                        fontSize: '14px',
                                                        color: 'rgba(16, 24, 40, 1)'
                                                    }}
                                                >
                                                    {row.name + " " + row.lastname}
                                                </Typography>
                                                <Typography variant="body2" color="textSecondary">
                                                    {row?.item?.phone}
                                                </Typography>
                                            </div>
                                        </TableCell>

                                        {type !== "gift" &&
                                            <TableCell>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={handleVehicleButtonClick(row.id)}
                                                    sx={{
                                                        backgroundColor: vehicleNoInputs[row.id]
                                                            ? 'rgba(236, 233, 233, 1)'
                                                            : 'rgba(255, 255, 255, 1)',
                                                        border: '1px solid rgba(208, 213, 221, 1)',
                                                        color: 'rgba(71, 84, 103, 1)',
                                                        fontWeight: vehicleNoInputs[row.id] ? '400' : '500',
                                                        fontSize: '14px',
                                                        paddingInline: '13px',
                                                        paddingTop: '6px',
                                                        paddingBottom: '6px',
                                                        '&:hover': {
                                                            backgroundColor: vehicleNoInputs[row.id]
                                                                ? 'rgba(236, 233, 233, 1)'
                                                                : 'rgba(255, 255, 255, 1)',
                                                            border: '1px solid rgba(208, 213, 221, 1)',
                                                        }
                                                    }}
                                                >
                                                    {vehicleNoInputs[row.id]?.trim() || 'Araç Seçin'}
                                                </Button>
                                            </TableCell>
                                        }

                                        <TableCell>
                                            <div
                                                style={{
                                                    height: '28px',
                                                    width: '28px',
                                                    paddingInline: '10px',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    display: 'flex',
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(208, 213, 221, 1)',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: 'rgba(71, 84, 103, 1)',
                                                    backgroundColor: 'white'
                                                }}
                                            >
                                                {type === "gift" ? row.packageCount : "1"}
                                            </div>
                                        </TableCell>
                                        <TableCell>{row?.item?.isPaid === "1"
                                                    ? "Ödendi"
                                                    : isPhysicalPos(row)
                                                        ? "Fiziksel POS Ödeme Bekleniyor"
                                                        : isCashPayment(row)
                                                            ? "Nakit Ödeme Bekleniyor"
                                                            : "Ödeme Bekliyor"}</TableCell>
                                        <TableCell>
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    backgroundColor: 'rgba(239, 248, 255, 1)',
                                                    border: '1px solid rgba(178, 221, 255, 1)',
                                                    color: 'rgba(23, 92, 211, 1)',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    paddingInline: '13px',
                                                    paddingTop: '6px',
                                                    paddingBottom: '6px',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(239, 248, 255, 1)',
                                                        border: '1px solid rgba(23, 92, 211, 1)'
                                                    }
                                                }}
                                                onClick={handleApproveSingle(row)}
                                                disabled={
                                                    (!vehicleNoInputs[row.id] ||
                                                        vehicleNoInputs[row.id].trim() === '' ||
                                                        (row?.item?.isPaid !== "1" && !requiresPhysicalPaymentFlow(row))) &&
                                                    type !== "gift"
                                                }
                                            >
                                                Onayla
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </DialogContent>
                </>
            ) : (
                <>
                    <DialogTitle
                        sx={{
                            m: 1,
                            p: 2,
                            position: 'relative',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography
                            sx={{
                                color: 'rgba(16, 24, 40, 1)',
                                fontWeight: '600',
                                fontSize: '16px'
                            }}
                        >
                            Araç Seçimi
                        </Typography>
                        <Typography
                            sx={{
                                color: 'rgba(154, 157, 161, 1)',
                                fontWeight: '400',
                                fontSize: '13px'
                            }}
                        >
                            Emanet için uygun aracı seçin
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sortDirection={orderByVehicle === 'code' ? orderVehicle : false}
                                    >
                                        <TableSortLabel
                                            active={orderByVehicle === 'code'}
                                            direction={orderByVehicle === 'code' ? orderVehicle : 'asc'}
                                            onClick={handleRequestSortVehicle('code')}
                                        >
                                            Araç Numarası
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell
                                        sortDirection={orderByVehicle === 'type' ? orderVehicle : false}
                                    >
                                        <TableSortLabel
                                            active={orderByVehicle === 'type'}
                                            direction={orderByVehicle === 'type' ? orderVehicle : 'asc'}
                                            onClick={handleRequestSortVehicle('type')}
                                        >
                                            Araç Tipi
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell
                                        sortDirection={orderByVehicle === 'color' ? orderVehicle : false}
                                    >
                                        <TableSortLabel
                                            active={orderByVehicle === 'color'}
                                            direction={orderByVehicle === 'color' ? orderVehicle : 'asc'}
                                            onClick={handleRequestSortVehicle('color')}
                                        >
                                            Renk
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell
                                        sortDirection={orderByVehicle === 'status' ? orderVehicle : false}
                                    >
                                        <TableSortLabel
                                            active={orderByVehicle === 'status'}
                                            direction={orderByVehicle === 'status' ? orderVehicle : 'asc'}
                                            onClick={handleRequestSortVehicle('status')}
                                        >
                                            Müsaitlik
                                        </TableSortLabel>
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            {type !== "gift" &&
                                <TableBody>
                                    {sortedVehicleOptions.map((item) => {
                                        const isSelected = selectedVehicleCode === item.barcode;
                                        return (
                                            <TableRow
                                                key={item.barcode}
                                                hover
                                                onClick={item.status === "available" && handleVehicleRowClick(item)}
                                                sx={{
                                                    cursor: 'pointer',
                                                    backgroundColor: isSelected
                                                        ? 'rgba(239, 248, 255, 1)'
                                                        : 'inherit'
                                                }}
                                            >
                                                <TableCell>
                                                    <Box component="span" sx={{
                                                        display: 'inline-block',
                                                        width: 8,
                                                        height: 8,
                                                        borderRadius: '50%',
                                                        backgroundColor: item.status === 'available' ? 'green' : 'red',
                                                        marginRight: 1
                                                    }} />
                                                    {item.barcode}
                                                </TableCell>
                                                <TableCell>
                                                    <Chip
                                                        label={type === "pet-car" ? "Pet Aracı" : "Çocuk Aracı"}
                                                        sx={{
                                                            backgroundColor: type === 'pet-car'
                                                                ? 'rgba(220, 232, 255, 1)'
                                                                : 'rgba(255, 229, 220, 1)',
                                                            border: type === 'pet-car'
                                                                ? '1px solid rgba(188, 204, 253, 1)'
                                                                : '1px solid rgba(253, 199, 188, 1)',
                                                            color: type === 'pet-car'
                                                                ? 'rgba(116, 123, 204, 1)'
                                                                : 'rgba(233, 114, 74, 1)',
                                                            borderRadius: '4px',
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Box
                                                        component="span"
                                                        sx={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: 1
                                                        }}
                                                    >
                                                        {item.color ? (
                                                            <Box
                                                                component="span"
                                                                sx={{
                                                                    display: 'inline-block',
                                                                    width: 10,
                                                                    height: 10,
                                                                    borderRadius: '50%',
                                                                    backgroundColor: item.color,
                                                                    border: '1px solid rgba(0,0,0,0.1)'
                                                                }}
                                                            />
                                                        ) : null}
                                                        <Typography sx={{ color: 'rgba(71, 84, 103, 1)' }}>
                                                            {item.color || '-'}
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={{
                                                        color: item.status === 'available'
                                                            ? 'rgba(53, 180, 120, 1)'
                                                            : 'rgba(233, 93, 80, 1)'
                                                    }}>
                                                        {item.status === "available" && "Uygun"}
                                                        {item.status === "in-use" && "Dolu"}
                                                        {item.status === "in-repair" && "Tamirde"}
                                                        {item.status === "lost" && "Kayıp"}
                                                        {item.status === "unavailable" && "Müsait Değil"}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            }

                        </Table>

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 3
                            }}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleConfirmVehicleSelection}
                                sx={{
                                    backgroundColor: 'rgba(32, 159, 99, 1)',
                                    color: '#fff',
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    mb: 2,
                                    width: '60%',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        backgroundColor: '#16a34a',
                                    },
                                }}
                            >
                                Seçimi Onayla
                            </Button>
                        </Box>
                    </DialogContent>
                </>
            )}

            <VehicleConfirmationDialog
                open={dialogOpen}
                vehicleNumbers={vehicleNumbers}
                onClose={handleCloseDialog}
                onConfirm={handleConfirm}
                setShowSucces={setShowSucces}
                showSucces={showSucces}
                type={type}
                requiresInvoice={requiresInvoice}
                invoiceNumber={invoiceNumber}
                setInvoiceNumber={setInvoiceNumber}
                onUpdatePaymentId={handleUpdatePaymentId}
                isUpdatingPaymentId={isUpdatingPaymentId}
                paymentIdConfirmed={paymentIdConfirmed}
            />
        </Dialog>
    );
}
